import Paragraph from "~/componentsDS/Typography/Paragraph";
import { cn } from "~/lib/utils";

const Divider = ({ className }: { className?: string }) => <div className={cn("my-[32px] h-[1px] w-full bg-gray200", className)} />;

const WhatItIsContent = () => (
    <div className="text-primary500">
        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-4 max-md:max-w-[252px] max-md:font-medium">
            At Inner Balance, we don’t believe women <br className="max-md:hidden"/>
            should overpay for exceptional care.
        </Paragraph>
        <Paragraph size="lg" className="mb-4">
            We source high-quality, prescription-grade ingredients and formulate them thoughtfully —
            then price our products based on real-world alternatives, not inflated “list prices.”
        </Paragraph>
        <Paragraph size="lg">
            To help you see the true value, we calculate a Total Value for each product.
        </Paragraph>

        <Divider />

        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-2 max-md:font-medium">
            What Is “Total Value”?
        </Paragraph>
        <Paragraph size="lg" className="mb-4">
            Total Value reflects what you would realistically pay to achieve the same
            outcome using comparable prescriptions, treatments, or multi-product regimens.
        </Paragraph>
        <Paragraph size="lg" weight="500" className="mb-2">
            To calculate it, we:
        </Paragraph>
        <ul className="list-disc pl-6">
            <li>
                <Paragraph size="lg">Identify 3–5 commonly used alternatives</Paragraph>
            </li>
            <li>
                <Paragraph size="lg">Track what patients actually pay (not “retail MSRP”)</Paragraph>
            </li>
            <li>
                <Paragraph size="lg">Average those costs to establish a fair comparison</Paragraph>
            </li>
        </ul>

        <Divider />

        <Paragraph size="lg" sizes={{ md: "2xl" }} className="mb-2">
            Our pricing is intentionally set below that Total Value <br className="max-md:hidden"/>
            — so you can clearly see the savings.
        </Paragraph>
        <Paragraph size="lg" className="max-md:mb-8">
            You’re not paying less because it’s inferior. <br />
            You’re paying less because it’s integrated, <br />
            efficient, and thoughtfully designed
        </Paragraph>

        <Divider className="max-md:hidden"/>

        <Paragraph size="xs" className="text-gray400">
            Total Value comparisons are estimates based on commonly prescribed alternatives and
            average out-of-pocket costs. Individual pricing and treatment plans vary.
        </Paragraph>
    </div>
);

export default WhatItIsContent;
